import { query, where } from "firebase/firestore";
import { SelectInputData } from "../../../../../components/deprecated/SelectInputField/SelectInputField";
import { ApiClientData } from "../../../../../libs/firebase/ApiClientData";
import { DataObjectType } from "../../DataObjects/DataObjectHelper";
import { LocalData } from "../../LocalData";
import { InputElementContext } from "../DataObjectField";
import { FirebaseDataSelectField, FirebaseDataSelectFieldOption } from "../Generic/FirebaseDataSelectField";

export class FirebaseDataApiClientField<FirebaseDataType extends DataObjectType> extends FirebaseDataSelectField<ApiClientData, FirebaseDataType> {
  encode = (value: ApiClientData) => value.id;
  override convertValueToSelectInput(value: ApiClientData): SelectInputData {
    return new SelectInputData(value.id + "", value.name);
  }
  getValueForKey(key: string): ApiClientData | undefined {
    return LocalData.apiClients.addData(key);
  }
  getOptions(): FirebaseDataSelectFieldOption[] {
    return LocalData.apiClients.documents.map((data) => {
      return {
        key: data.id,
        label: data.name,
      };
    });
  }
  getReadableStringRepresentation(value: ApiClientData): string {
    return value.name;
  }

  loadAllDatas(context?: InputElementContext): Promise<void> {
    return Promise.all([
      new Promise((resolve) =>
        LocalData.apiClients.loadWithFilter(
          (ref) => query(ref, where("isPublic", "==", true)),
          (docs) => {
            resolve(docs);
          }
        )
      ),
    ]).then(() => {});
  }

  override isValueValid = (value: any): boolean => {
    return value instanceof ApiClientData;
  };
}

